import { Typography } from 'antd';
import type { TechniciansTabPageViewProps } from './TechniciansTabPage.types';

export function TechniciansTabPageView({ title }: TechniciansTabPageViewProps) {
  return <Typography.Title level={3}>{title}</Typography.Title>;
}
